import React, { useEffect, useMemo, useState } from "react";
import { Button, Box, Typography } from "@mui/material";
import style from "../../../../styles/brsr/general.module.css";
import EastIcon from "@mui/icons-material/East";
import { get, put } from "../../../../utils/api";
import DynamicTable from "../../../Common/DynamicTable";
import { validateFields, validateTable } from "../../../../utils/validateTable";
import { restructureData } from "../../../../utils/restructureData";
import RadioButtons from "../../../Common/RadioButtons";
import InputField from "../../../Masters/InputField";
import Multiline from "../../../Masters/Multiline";
import TableData from "../../../Common/TableData";
import ComplaintTable from "./ComplaintTable";
import RelatedTransactionsTable from "./RelatedTransaction";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CircleIcon from "@mui/icons-material/Circle";
import { validateDays, validateNumber } from "../../../../utils/validateFields";
import { numberError } from "../../../../utils/validationMessage";
import MessagePopup from "../../../Masters/MessagePopup";
import { useParams } from "react-router-dom";
import { brsrReview, reviewBRSR } from "../../../../utils/companyId";
import ReviewBox from "../../../Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";
import {
  getFinancialYearLabels,
  fetchYearFromBrsrList,
  extractReportingYearFromBrsrGetResponse,
} from "../../../../utils/brsrFinancialYearLabels";
import BRSRFile from "../../../Common/BRSRFile";

const inputData = {
  // 1
  percentageData: [
    {
      fieldName: "percentageCoverageByTraining",
      title:
        "1. Percentage coverage by training & awareness programs on any of the Principles during the financial year :",
      type: "array",
      fields: [
        {
          fieldName: "awarenessProgramHeld",
          title: "Total number of training and awareness programmes held",
          placeholder: "Enter Number",
          type: "number",
          width: "10rem",
        },
        {
          fieldName: "principleUnderTraining",
          title:
            "Topics / principles covered under the training and its impact",
          placeholder: "Select",
          type: "select",
          options: [
            "Select All",
            "P1",
            "P2",
            "P3",
            "P4",
            "P5",
            "P6",
            "P7",
            "P8",
            "P9",
          ],
          width: "12rem",
        },
        {
          fieldName: "categoryCoveredPercentage",
          title:
            "% age of persons in respective category covered by the awareness programmes",
          placeholder: "Enter Percentage",
          type: "percentage",
          width: "12rem",
        },
      ],
    },
  ],
  // 2
  monetryData: [
    {
      fieldName: "monetaryDetails",
      // title: "Monetary",
      type: "array",
      fields: [
        {
          fieldName: "ngrbcPrinciple",
          title: "NGRBC Principle",
          placeholder: "Select",
          type: "select",
          options: [
            "Select All",
            "P1",
            "P2",
            "P3",
            "P4",
            "P5",
            "P6",
            "P7",
            "P8",
            "P9",
          ],
          width: "10rem",
        },
        {
          fieldName: "regulatoryAgency",
          title: "Regulatory Agency",
          placeholder: "Enter Text",
          type: "text",
          width: "8rem",
        },
        {
          fieldName: "amountInINR",
          title: "Amount (In INR)",
          placeholder: "Number",
          type: "number",
          width: "6rem",
        },
        {
          fieldName: "caseBrief",
          title: "Brief of the case",
          placeholder: "Enter Text",
          type: "text",
          width: "8rem",
        },
        {
          fieldName: "hasAppealPreferred",
          title: "Has an appeal been preferred? ",
          placeholder: "Enter Text",
          type: "radio",
          width: "9rem",
        },
      ],
    },
  ],
  // nonMonetry
  nonMonetryData: [
    {
      fieldName: "nonMonetaryDetails",
      // title: "Non-Monetary",
      type: "array",
      fields: [
        {
          fieldName: "ngrbcPrinciple",
          title: "NGRBC Principle",
          placeholder: "Select",
          type: "select",
          options: [
            "Select All",
            "P1",
            "P2",
            "P3",
            "P4",
            "P5",
            "P6",
            "P7",
            "P8",
            "P9",
          ],
          width: "12rem",
        },
        {
          fieldName: "regulatoryAgency",
          title: "Regulatory Agency",
          placeholder: "Enter Text",
          type: "text",
          width: "8rem",
        },
        {
          fieldName: "caseBrief",
          title: "Case Brief",
          placeholder: "Enter Text",
          type: "text",
          width: "10rem",
        },
        {
          fieldName: "hasAppealPreferred",
          title: "Has an appeal been preferred? ",
          type: "radio",
          width: "9rem",
        },
      ],
    },
  ],
  // 3
  appealData: [
    {
      fieldName: "appealDetails",
      // title:
      //   "3. Of the instances disclosed in Question 2 above, details of appeal/revision preferred in cases where monetary or non-monetary action has been appealed",
      type: "array",
      fields: [
        {
          fieldName: "regulatoryEnforcement",
          title: "Name of regulatory/enforcement ",
          placeholder: "Enter Text",
          type: "text",
          width: "25rem",
        },
        {
          fieldName: "caseDetails",
          title: "Case Details",
          placeholder: "Enter Text",
          type: "text",
          width: "25rem",
        },
      ],
    },
  ],
  disciplinaryData: [
    {
      fieldName: "disciplinaryActions",
      title:
        " 5. Number of Directors/ KMPs/ employees/ workers against whom disciplinary action was taken by any law enforcement agency for the charge of bribery/corruption :",
      type: "array",
      fields: [
        {
          fieldName: "currentYear",
          title: "Current Financial Year",
          placeholder: "Enter Number",
          type: "number",
          width: "10rem",
        },
        {
          fieldName: "previousYear",
          title: "Previous Financial Year",
          placeholder: "Enter Number",
          type: "number",
          width: "10rem",
        },
      ],
    },
  ],

  relatedPartyTransactionsData: [
    {
      parameter: "Concentration of Purchases",
      metrics: [
        {
          label: "a. Purchases from trading houses as % of total purchases",
          fieldPath: "concentrationOfPurchased.purchasedFromTrading",
          isPercentage: true,
        },
        {
          label: "b. Number of trading houses where purchases are made from",
          fieldPath: "concentrationOfPurchased.purchasedAreMadeFrom",
        },
        {
          label:
            "c. Purchases from top 10 trading houses as % of total purchases from trading houses",
          fieldPath: "concentrationOfPurchased.top10TradingHouse",
          isPercentage: true,
        },
      ],
    },
    {
      parameter: "Concentration of Sales",
      metrics: [
        {
          label: "a. Sales to dealers / distributors as % of total sales",
          fieldPath: "concentrationOfSales.salesOfDealerDistributors",
          isPercentage: true,
        },
        {
          label: "b. Number of dealers / distributors to whom sales are made",
          fieldPath: "concentrationOfSales.salesAreMade",
        },
        {
          label:
            "c. Sales to top 10 dealers / distributors as % of total sales to dealers / distributors",
          fieldPath: "concentrationOfSales.top10dealers",
          isPercentage: true,
        },
      ],
    },
    {
      parameter: "Share of RPTs in",
      metrics: [
        {
          label:
            "a. Purchases (Purchases with related parties / Total Purchases)",
          fieldPath: "shareOfRPTs.purchases",
        },
        {
          label: "b. Sales (Sales to related parties / Total Sales)",
          fieldPath: "shareOfRPTs.sales",
        },
        {
          label:
            "c. Loans & advances (Loans & advances given to related parties / Total loans & advances)",
          fieldPath: "shareOfRPTs.loans",
        },
        {
          label:
            "d. Investments (Investments in related parties / Total Investments made)",
          fieldPath: "shareOfRPTs.investments",
        },
      ],
    },
  ],
};

/** Default shape for Principle 1 indicator 9 (openness / related-party concentration). */
const getEmptyPrinciple1RelatedPartyTransactions = () => ({
  concentrationOfPurchased: {
    purchasedFromTrading: {
      currentFinancialYear: "",
      previousFinancialYear: "",
    },
    purchasedAreMadeFrom: {
      currentFinancialYear: "",
      previousFinancialYear: "",
    },
    top10TradingHouse: {
      currentFinancialYear: "",
      previousFinancialYear: "",
    },
  },
  concentrationOfSales: {
    salesOfDealerDistributors: {
      currentFinancialYear: "",
      previousFinancialYear: "",
    },
    salesAreMade: {
      currentFinancialYear: "",
      previousFinancialYear: "",
    },
    top10dealers: {
      currentFinancialYear: "",
      previousFinancialYear: "",
    },
  },
  shareOfRPTs: {
    purchases: {
      currentFinancialYear: "",
      previousFinancialYear: "",
    },
    sales: {
      currentFinancialYear: "",
      previousFinancialYear: "",
    },
    loans: {
      currentFinancialYear: "",
      previousFinancialYear: "",
    },
    investments: {
      currentFinancialYear: "",
      previousFinancialYear: "",
    },
  },
});

const ensurePrinciple1RelatedPartyTransactions = (value) =>
  value != null && typeof value === "object"
    ? value
    : getEmptyPrinciple1RelatedPartyTransactions();

const EssentialIndicator = ({
  onSave,
  hide,
  removeUpload = false,
  downloadMode = false,
}) => {
  const { id } = useParams();
  const [modalupload, setModalUpload] = useState({
    percentageCoverageByTrainingDoc: false,
    moneterynonMonetaryDoc: false,
    appealDetailsDDoc: false,
    antiCorruptionPolicyDoc: false,
    disciplinaryActionsDoc: false,
    conflictOfInterestComplaintsDoc: false,
    correctiveActionsDoc: false,
    accountsPayablesDoc: false,
    relatedPartyTransactionsDoc: false,
  });
  const [tables, setTables] = useState([]);
  const [errors, setErrors] = useState({});
  const [tabErrors, setTabErrors] = useState({});
  const [data, setData] = useState({});
  const [complaintError, setComplaintError] = useState({});
  const [relatedErrors, setRelatedErrors] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [disabled, setDisabled] = useState(false);
  const [reportingFinancialYear, setReportingFinancialYear] = useState("");
  const [formData, setFormData] = useState({});
  const [formData2, setFormData2] = useState({});

  const relatedPartyFyColumnLabels = useMemo(() => {
    const { currentYear, previousYear } =
      getFinancialYearLabels(reportingFinancialYear);
    return {
      current: currentYear
        ? `FY ${currentYear} (Current Financial Year)`
        : "FY ____ (Current Financial Year)",
      previous: previousYear
        ? `FY ${previousYear} (Previous Financial Year)`
        : "FY ____ (Previous Financial Year)",
    };
  }, [reportingFinancialYear]);

  const fetchData = async () => {
    let listYear = "";
    try {
      listYear = await fetchYearFromBrsrList(get, id);
      const res = await get(
        `/brsr/get?id=${id}&subType=principle1&type=SectionC`,
      );
      setReportingFinancialYear(
        listYear || extractReportingYearFromBrsrGetResponse(res) || "",
      );

      const res1 =
        res?.data?.data?.BRSRSectionC?.principle1?.essentialIndicators;
      if (res1 == null || typeof res1 !== "object") {
        setData(res1);
      } else {
        setData({
          ...res1,
          relatedPartyTransactions:
            ensurePrinciple1RelatedPartyTransactions(
              res1.relatedPartyTransactions,
            ),
          relatedPartyTransactionsDoc: Array.isArray(
            res1.relatedPartyTransactionsDoc,
          )
            ? res1.relatedPartyTransactionsDoc
            : [],
        });
      }
      if (
        res?.data?.data?.year
          ? res?.data?.data?.year < currentYear - 1
          : false || !brsrReview
      )
        setDisabled(true);
    } catch (err) {
      console.log(err);
      setReportingFinancialYear(listYear || "");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const state = {
      percentageCoverageByTrainingDoc:
        data?.percentageCoverageByTrainingDoc ?? [],
      moneterynonMonetaryDoc: data?.moneterynonMonetaryDoc ?? [],
      appealDetailsDDoc: data?.appealDetailsDDoc ?? [],
      antiCorruptionPolicyDoc: data?.antiCorruptionPolicyDoc ?? [],
      disciplinaryActionsDoc: data?.disciplinaryActionsDoc ?? [],
      conflictOfInterestComplaintsDoc:
        data?.conflictOfInterestComplaintsDoc ?? [],
      correctiveActionsDoc: data?.correctiveActionsDoc ?? [],
      accountsPayablesDoc: data?.accountsPayablesDoc ?? [],
      relatedPartyTransactionsDoc: data?.relatedPartyTransactionsDoc ?? [],
      percentageCoverageByTraining: {
        boardOfDirectors: {
          categoryCoveredPercentage:
            data?.percentageCoverageByTraining?.boardOfDirectors
              ?.categoryCoveredPercentage ?? "",
          awarenessProgramHeld:
            data?.percentageCoverageByTraining?.boardOfDirectors
              ?.awarenessProgramHeld ?? "",
          principleUnderTraining:
            data?.percentageCoverageByTraining?.boardOfDirectors
              ?.principleUnderTraining ?? [],
        },
        keyManagementPersonnel: {
          categoryCoveredPercentage:
            data?.percentageCoverageByTraining?.keyManagementPersonnel
              ?.categoryCoveredPercentage ?? "",
          awarenessProgramHeld:
            data?.percentageCoverageByTraining?.keyManagementPersonnel
              ?.awarenessProgramHeld ?? "",
          principleUnderTraining:
            data?.percentageCoverageByTraining?.keyManagementPersonnel
              ?.principleUnderTraining ?? [],
        },
        employeesOtherThanBoDAndKMPs: {
          categoryCoveredPercentage:
            data?.percentageCoverageByTraining?.employeesOtherThanBoDAndKMPs
              ?.categoryCoveredPercentage ?? "",
          awarenessProgramHeld:
            data?.percentageCoverageByTraining?.employeesOtherThanBoDAndKMPs
              ?.awarenessProgramHeld ?? "",
          principleUnderTraining:
            data?.percentageCoverageByTraining?.employeesOtherThanBoDAndKMPs
              ?.principleUnderTraining ?? [],
        },
        workers: {
          categoryCoveredPercentage:
            data?.percentageCoverageByTraining?.workers
              ?.categoryCoveredPercentage ?? "",
          awarenessProgramHeld:
            data?.percentageCoverageByTraining?.workers?.awarenessProgramHeld ??
            "",
          principleUnderTraining:
            data?.percentageCoverageByTraining?.workers
              ?.principleUnderTraining ?? [],
        },
      },
      detailsOfFine: data?.detailsOfFine,
      monetary: {
        penaltyFine: {
          ngrbcPrinciple: data?.monetary?.penaltyFine?.ngrbcPrinciple ?? "",
          regulatoryAgency: data?.monetary?.penaltyFine?.regulatoryAgency ?? "",
          amountInINR: data?.monetary?.penaltyFine?.amountInINR ?? "",
          caseBrief: data?.monetary?.penaltyFine?.caseBrief ?? "",
          hasAppealPreferred: data?.monetary?.hasAppealPreferred ?? true,
        },
        settlement: {
          ngrbcPrinciple: data?.monetary?.settlement?.ngrbcPrinciple ?? "",
          regulatoryAgency: data?.monetary?.settlement?.regulatoryAgency ?? "",
          amountInINR: data?.monetary?.settlement?.amountInINR ?? "",
          caseBrief: data?.monetary?.settlement?.caseBrief ?? "",
          hasAppealPreferred: data?.monetary?.hasAppealPreferred ?? true,
        },
        compoundingFee: {
          ngrbcPrinciple: data?.monetary?.compoundingFee?.ngrbcPrinciple ?? "",
          regulatoryAgency:
            data?.monetary?.compoundingFee?.regulatoryAgency ?? "",
          amountInINR: data?.monetary?.compoundingFee?.amountInINR ?? "",
          caseBrief: data?.monetary?.compoundingFee?.caseBrief ?? "",
          hasAppealPreferred: data?.monetary?.hasAppealPreferred ?? true,
        },
      },
      nonMonetary: {
        imprisonment: {
          ngrbcPrinciple: data?.nonMonetary?.imprisonment?.ngrbcPrinciple ?? "",
          regulatoryAgency:
            data?.nonMonetary?.imprisonment?.regulatoryAgency ?? "",
          amountInINR: data?.nonMonetary?.imprisonment?.amountInINR ?? "",
          caseBrief: data?.nonMonetary?.imprisonment?.caseBrief ?? "",
          hasAppealPreferred: data?.nonMonetary?.hasAppealPreferred ?? true,
        },
        punishment: {
          ngrbcPrinciple: data?.nonMonetary?.punishment?.ngrbcPrinciple ?? "",
          regulatoryAgency:
            data?.nonMonetary?.punishment?.regulatoryAgency ?? "",
          amountInINR: data?.nonMonetary?.punishment?.amountInINR ?? "",
          caseBrief: data?.nonMonetary?.punishment?.caseBrief ?? "",
          hasAppealPreferred:
            data?.nonMonetary?.punishment?.hasAppealPreferred ?? true,
        },
      },
      appealDetails: data?.appealDetails ?? [
        {
          regulatoryEnforcement: "",
          caseDetails: "",
        },
      ],
      antiCorruptionPolicy: {
        hasPolicy: data?.antiCorruptionPolicy?.hasPolicy ?? false,
        policyDetails: data?.antiCorruptionPolicy?.policyDetails ?? "",
        policyLink: data?.antiCorruptionPolicy?.policyLink ?? "",
      },
      disciplinaryActions: {
        boardOfDirectors: data?.disciplinaryActions?.boardOfDirectors ?? "",
        keyManagementPersonnel:
          data?.disciplinaryActions?.keyManagementPersonnel ?? "",
        employeesOtherThanBoDAndKMPs:
          data?.disciplinaryActions?.employeesOtherThanBoDAndKMPs ?? "",
        workers: data?.disciplinaryActions?.workers ?? "",
      },
      conflictOfInterestComplaints: {
        currentFinancialYear: {
          directors: {
            numberOfComplaints:
              data?.conflictOfInterestComplaints?.currentFinancialYear
                ?.directors?.numberOfComplaints ?? "",
            remarks:
              data?.conflictOfInterestComplaints?.currentFinancialYear
                ?.directors?.remarks ?? "",
          },
          keyManagement: {
            numberOfComplaints:
              data?.conflictOfInterestComplaints?.currentFinancialYear
                ?.keyManagement?.numberOfComplaints ?? "",
            remarks:
              data?.conflictOfInterestComplaints?.currentFinancialYear
                ?.keyManagement?.remarks ?? "",
          },
        },
        previousFinancialYear: {
          directors: {
            numberOfComplaints:
              data?.conflictOfInterestComplaints?.previousFinancialYear
                ?.directors?.numberOfComplaints ?? "",
            remarks:
              data?.conflictOfInterestComplaints?.previousFinancialYear
                ?.directors?.remarks ?? "",
          },
          keyManagement: {
            numberOfComplaints:
              data?.conflictOfInterestComplaints?.previousFinancialYear
                ?.keyManagement?.numberOfComplaints ?? "",
            remarks:
              data?.conflictOfInterestComplaints?.previousFinancialYear
                ?.keyManagement?.remarks ?? "",
          },
        },
      },
      correctiveActions: data?.correctiveActions ?? "",
      accountsPayables: {
        currentFinancialYear:
          data?.accountsPayables?.currentFinancialYear ?? "",
        previousFinancialYear:
          data?.accountsPayables?.previousFinancialYear ?? "",
      },
      relatedPartyTransactions: {
        concentrationOfPurchased: {
          purchasedFromTrading: {
            currentFinancialYear:
              data?.relatedPartyTransactions?.concentrationOfPurchased
                ?.purchasedFromTrading?.currentFinancialYear ?? "",
            previousFinancialYear:
              data?.relatedPartyTransactions?.concentrationOfPurchased
                ?.purchasedFromTrading?.previousFinancialYear ?? "",
          },
          purchasedAreMadeFrom: {
            currentFinancialYear:
              data?.relatedPartyTransactions?.concentrationOfPurchased
                ?.purchasedAreMadeFrom?.currentFinancialYear ?? "",
            previousFinancialYear:
              data?.relatedPartyTransactions?.concentrationOfPurchased
                ?.purchasedAreMadeFrom?.previousFinancialYear ?? "",
          },
          top10TradingHouse: {
            currentFinancialYear:
              data?.relatedPartyTransactions?.concentrationOfPurchased
                ?.top10TradingHouse?.currentFinancialYear ?? "",
            previousFinancialYear:
              data?.relatedPartyTransactions?.concentrationOfPurchased
                ?.top10TradingHouse?.previousFinancialYear ?? "",
          },
        },

        concentrationOfSales: {
          salesOfDealerDistributors: {
            currentFinancialYear:
              data?.relatedPartyTransactions?.concentrationOfSales
                ?.salesOfDealerDistributors?.currentFinancialYear ?? "",
            previousFinancialYear:
              data?.relatedPartyTransactions?.concentrationOfSales
                ?.salesOfDealerDistributors?.previousFinancialYear ?? "",
          },
          salesAreMade: {
            currentFinancialYear:
              data?.relatedPartyTransactions?.concentrationOfSales?.salesAreMade
                ?.currentFinancialYear ?? "",
            previousFinancialYear:
              data?.relatedPartyTransactions?.concentrationOfSales?.salesAreMade
                ?.previousFinancialYear ?? "",
          },
          top10dealers: {
            currentFinancialYear:
              data?.relatedPartyTransactions?.concentrationOfSales?.top10dealers
                ?.currentFinancialYear ?? "",
            previousFinancialYear:
              data?.relatedPartyTransactions?.concentrationOfSales?.top10dealers
                ?.previousFinancialYear ?? "",
          },
        },
        shareOfRPTs: {
          purchases: {
            currentFinancialYear:
              data?.relatedPartyTransactions?.shareOfRPTs?.purchases
                ?.currentFinancialYear ?? "",
            previousFinancialYear:
              data?.relatedPartyTransactions?.shareOfRPTs?.purchases
                ?.previousFinancialYear ?? "",
          },
          sales: {
            currentFinancialYear:
              data?.relatedPartyTransactions?.shareOfRPTs?.sales
                ?.currentFinancialYear ?? "",
            previousFinancialYear:
              data?.relatedPartyTransactions?.shareOfRPTs?.sales
                ?.previousFinancialYear ?? "",
          },
          loans: {
            currentFinancialYear:
              data?.relatedPartyTransactions?.shareOfRPTs?.loans
                ?.currentFinancialYear ?? "",
            previousFinancialYear:
              data?.relatedPartyTransactions?.shareOfRPTs?.loans
                ?.previousFinancialYear ?? "",
          },
          investments: {
            currentFinancialYear:
              data?.relatedPartyTransactions?.shareOfRPTs?.investments
                ?.currentFinancialYear ?? "",
            previousFinancialYear:
              data?.relatedPartyTransactions?.shareOfRPTs?.investments
                ?.previousFinancialYear ?? "",
          },
        },
      },
    };
    setFormData(state);
    setFormData2(state);
  }, [data]);

  const defaultSegments = {
    monetry: [
      { title: "Penalty/ Fine", field: "penaltyFine" },
      { title: "Settlement", field: "settlement" },
      { title: "Compounding fee", field: "compoundingFee" },
    ],
    nonMonetary: [
      { title: "Imprisonment", field: "imprisonment" },
      { title: "Punishment", field: "punishment" },
    ],
    percentage: [
      { title: "Board of Directors", field: "boardOfDirectors" },
      {
        title: "Key Management Personnel",
        field: "keyManagementPersonnel",
      },
      {
        title: "Employees other than BoD and KMPs",
        field: "employeesOtherThanBoDAndKMPs",
      },
      { title: "Workers", field: "workers" },
    ],
    desciplinary: [
      { title: "Board of Directors", field: "boardOfDirectors" },
      {
        title: "Key Management Personnel",
        field: "keyManagementPersonnel",
      },
      {
        title: "Employees other than BoD and KMPs",
        field: "employeesOtherThanBoDAndKMPs",
      },
      { title: "Workers", field: "workers" },
    ],
  };

  const [percentTable, setPercentTable] = useState({});
  const [monetryTable, setMonetryTable] = useState({});
  const [nonMonetryTable, setNonMonetryTable] = useState({});
  const [desciplinaryTable, setDesciplinaryTable] = useState({});

  useEffect(() => {
    if (formData2?.percentageCoverageByTraining) {
      setPercentTable(formData2.percentageCoverageByTraining);
    }
    if (formData2?.monetary) {
      setMonetryTable(formData2.monetary);
    }
    if (formData2?.nonMonetary) {
      setNonMonetryTable(formData2.nonMonetary);
    }
    if (formData2?.disciplinaryActions) {
      setDesciplinaryTable(formData2.disciplinaryActions);
    }
  }, [formData2]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const [field, key] = name.split(".");
    if (field === "accountsPayables" && !validateDays(value)) return;

    if (name === "correctiveActions") {
      setFormData((prev) => ({
        ...prev,
        [name]: value, // Update the specific key
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [field]: {
          ...prev[field], // Correctly access the dynamic field
          [key]: value, // Update the specific key
        },
      }));
    }

    setErrors((prev) => ({
      ...prev,
      [name]: "", // Update the specific key
    }));
  };

  const validateInputs = () => {
    const validationErrors = {};

    const fieldDisplayNames = {
      numberOfComplaints: "Number of Complaints",
      remarks: "Remarks",
    };

    ["directors", "keyManagement"].forEach((role) => {
      ["currentFinancialYear", "previousFinancialYear"].forEach((year) => {
        ["numberOfComplaints"].forEach((field) => {
          const value =
            formData["conflictOfInterestComplaints"][year]?.[role]?.[field] ===
            0
              ? 0
              : (formData["conflictOfInterestComplaints"][year]?.[role]?.[
                  field
                ] ?? "");
          if (value === "") {
            // Ensure the structure of validationErrors is based on the role
            validationErrors[role] = validationErrors[role] ?? {};
            validationErrors[role][year] = validationErrors[role][year] ?? {};
            validationErrors[role][year][field] = fieldDisplayNames[field]; // Use the readable field name
          }
        });
      });
    });

    setComplaintError(validationErrors);
    return Object.keys(validationErrors).length === 0;
  };

  const validateForm = () => {
    const newErrors = {};

    if (formData?.antiCorruptionPolicy?.hasPolicy) {
      if (!formData?.antiCorruptionPolicy?.policyDetails?.trim())
        newErrors["antiCorruptionPolicy.policyDetails"] =
          "This field is Required";

      const urlPattern =
        /^(https?:\/\/)?(www\.)?(([\p{L}0-9-]+\.)+[\p{L}]{2,}|(\d{1,3}\.){3}\d{1,3})(:\d{2,5})?(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/u;
      // if (!formData?.antiCorruptionPolicy?.policyLink?.trim())
      //   newErrors["antiCorruptionPolicy.policyLink"] = "Required";
      if (
        formData?.antiCorruptionPolicy?.policyLink?.trim() &&
        !urlPattern.test(formData.antiCorruptionPolicy.policyLink.trim())
      )
        newErrors["antiCorruptionPolicy.policyLink"] = "Enter a valid URL";
    }
    if (formData?.correctiveActions === "")
      newErrors["correctiveActions"] = "This field is Required";

    if (formData?.accountsPayables.currentFinancialYear === "")
      newErrors["accountsPayables.currentFinancialYear"] =
        "This field is Required";

    if (!validateNumber(formData?.accountsPayables.currentFinancialYear ?? 0))
      newErrors["accountsPayables.currentFinancialYear"] = numberError;

    if (formData?.accountsPayables.previousFinancialYear === "")
      newErrors["accountsPayables.previousFinancialYear"] =
        "This field is Required";

    if (!validateNumber(formData?.accountsPayables.previousFinancialYear ?? 0))
      newErrors["accountsPayables.previousFinancialYear"] = numberError;

    if (!formData?.antiCorruptionPolicy?.hasPolicy)
      setFormData((prev) => ({
        ...prev,
        antiCorruptionPolicy: {
          ...prev.antiCorruptionPolicy,
          policyDetails: "",
          policyLink: "",
        },
      }));

    setErrors((prev) => ({
      ...prev, // Spread the previous errors
      ...newErrors, // Update or add the new error for the specific field (or name)
    }));
    return Object.keys(newErrors).length === 0;
  };

  const validateRelatedPartyTransactions = () => {
    const validationErrors = {};
    const data = inputData.relatedPartyTransactionsData;

    data.forEach((item) => {
      item.metrics.forEach((metric) => {
        const [field1, field2] = metric.fieldPath.split(".");
        const node =
          formData?.relatedPartyTransactions?.[field1]?.[field2] ?? {};

        ["currentFinancialYear", "previousFinancialYear"].forEach((yr) => {
          const raw = node[yr];
          const value = raw === 0 ? 0 : (raw ?? "");
          const key = `${metric.fieldPath}.${yr}`;

          if (value === "") {
            validationErrors[key] = "This field is Required";
            return;
          }
          const num = Number(value);
          if (!validateNumber(num)) {
            validationErrors[key] = numberError;
            return;
          }
          if (metric.isPercentage && num > 100) {
            validationErrors[key] = "Value must not exceed 100";
          }
        });
      });
    });

    setRelatedErrors(validationErrors);
    return Object.keys(validationErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      let v1 = validateFields(
        percentTable,
        inputData.percentageData,
        defaultSegments.percentage,
        setErrors,
        errors,
        "percentErrors",
      );

      let v2 = true,
        v3 = true,
        v4 = true,
        transformedData;
      if (formData?.detailsOfFine) {
        v2 = validateFields(
          monetryTable,
          inputData.monetryData,
          defaultSegments.monetry,
          setErrors,
          errors,
          "monetary",
        );
        v3 = validateFields(
          nonMonetryTable,
          inputData.nonMonetryData,
          defaultSegments.nonMonetary,
          setErrors,
          errors,
          "nonMonetary",
        );
        v4 = validateTable(inputData?.appealData, tables, setTabErrors);
        transformedData = restructureData(tables);
      }

      let v5 = validateFields(
        desciplinaryTable,
        inputData.disciplinaryData,
        defaultSegments.desciplinary,
        setErrors,
        errors,
        "desciplinary",
      );

      let v6 = validateInputs();
      let v7 = validateForm();
      let v8 = validateRelatedPartyTransactions();

      if (!v1 || !v2 || !v3 || !v4 || !v5 || !v6 || !v7 || !v8) return;

      let appealDetails = formData?.detailsOfFine
        ? transformedData
        : { appealDetails: [] };

      let transformedData2 = {
        essentialIndicators: {
          ...{
            ...formData,
            antiCorruptionPolicy: {
              ...formData?.antiCorruptionPolicy,
              policyDetails: !formData?.antiCorruptionPolicy?.hasPolicy
                ? ""
                : formData?.antiCorruptionPolicy?.policyDetails,
              policyLink: !formData?.antiCorruptionPolicy?.hasPolicy
                ? ""
                : formData?.antiCorruptionPolicy?.policyLink,
            },
          },
          percentageCoverageByTraining: percentTable,
          monetary: formData?.detailsOfFine ? monetryTable : [],
          nonMonetary: formData?.detailsOfFine ? nonMonetryTable : [],
          ...appealDetails,
          disciplinaryActions: desciplinaryTable,
          relatedPartyTransactions:
            ensurePrinciple1RelatedPartyTransactions(
              formData?.relatedPartyTransactions,
            ),
          relatedPartyTransactionsDoc: Array.isArray(
            formData?.relatedPartyTransactionsDoc,
          )
            ? formData.relatedPartyTransactionsDoc
            : [],
        },
        essentialIndicatorsSubmitted: true,
        type: "SectionC",
        subType: "principle1",
      };

      try {
        const res = await put(`/brsr/update?id=${id}`, transformedData2);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });

        onSave();
      } catch (error) {
        setsnackOpen({
          open: true,
          message: error.data.message,
          severity: "error",
        });
      }
    } else onSave();
  };

  return (
    <Box>
      <p className={style.subHeading}>I. ESSENTIAL INDICATOR</p>
      {/* 1 */}
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      <TableData
        defaultSegments={defaultSegments?.percentage || ""}
        inputData={inputData?.percentageData}
        errors={errors["percentErrors"]}
        setErrors={setErrors}
        tables={percentTable}
        setTables={setPercentTable}
        name="percentErrors"
        defaultWidth={"8rem"}
        disabled={disabled}
      />
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "percentageCoverageByTrainingDoc",
          ml: 2,
          removeUpload,
        }}
      />
      {/* 2 */}
      <Box>
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: "16px",
            mt: 2,
            lineHeight: "24px",
            textIndent: "-1.1rem",
            paddingLeft: "1.1rem",
            fontFamily: "Inter",
          }}
          gutterBottom
        >
          2. Details of fines/ penalties/ punishment/ award/ compounding fees/
          settlement amount paid in proceedings (by the entity or by directors/
          KMPs) with regulators/ law enforcement agencies/ judicial
          institutions, in the financial year, in the following format:
        </Typography>
        <Typography
          sx={{
            fontWeight: 400,
            lineHeight: "24px",
            fontSize: "16px",
            fontStyle: "Inter",
            textIndent: "-1.4rem",
            marginLeft: "1.1rem",
          }}
        >
          <InfoOutlinedIcon sx={{ fontSize: "18px" }} /> (Note: The entity shall
          make disclosures on the basis of materiality as specified in
          Regulation 30 of SEBI (Listing Obligations and Disclosure Obligations)
          Regulations, 2015 and as disclosed on the entity's website):
        </Typography>
        <RadioButtons
          value={formData?.detailsOfFine || false}
          disabled={disabled}
          handleChange={(e) => {
            const value = e.target.value === "true"; // Convert string to boolean
            setFormData((prev) => ({ ...prev, detailsOfFine: value }));
          }}
        />
        {formData?.detailsOfFine && (
          <Box>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: "bold", mb: "-1rem", mt: "1rem", ml: 2 }}
            >
              <CircleIcon sx={{ fontSize: "6px", mt: "-0.3rem", mr: 1 }} />{" "}
              Monetary
            </Typography>
            <TableData
              defaultSegments={defaultSegments?.monetry || ""}
              defaultWidth={"9rem"}
              inputData={inputData?.monetryData}
              errors={errors["monetary"]}
              setErrors={setErrors}
              tables={monetryTable}
              setTables={setMonetryTable}
              name="monetary"
              disabled={disabled}
            />
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: "bold", mb: "-1rem", ml: 2 }}
            >
              <CircleIcon sx={{ fontSize: "6px", mt: "-0.3rem", mr: 1 }} />{" "}
              Non-Monetary
            </Typography>
            <TableData
              defaultSegments={defaultSegments?.nonMonetary || ""}
              inputData={inputData?.nonMonetryData}
              errors={errors["nonMonetary"]}
              setErrors={setErrors}
              tables={nonMonetryTable}
              setTables={setNonMonetryTable}
              name="nonMonetary"
              defaultWidth={"6rem"}
              disabled={disabled}
            />
          </Box>
        )}
      </Box>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "moneterynonMonetaryDoc",
          ml: 2,
          removeUpload,
        }}
      />
      {/* 3 */}
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "16px",
          lineHeight: "24px",
          mt: 2,
          width: "99%",
          textIndent: "-1.1rem",
          paddingLeft: "1rem",
          fontFamily: "Inter",
        }}
      >
        3. Of the instances disclosed in Question 2 above, details of the
        Appeal/ Revision preferred in cases where monetary or non-monetary
        action has been appealed
      </Typography>
      {formData?.detailsOfFine ? (
        <Box sx={{ mt: "-1rem" }}>
          <DynamicTable
            {...{
              inputData: inputData?.appealData,
              handleSubmit,
              tables,
              setTables,
              errors: tabErrors,
              setErrors: setTabErrors,
              data: formData2,
              disabled,
              hide,
            }}
          />
        </Box>
      ) : (
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: "16px",
            lineHeight: "24px",
            ml: 2,
            my: 1,
            fontFamily: "Inter",
          }}
          gutterBottom
        >
          Not Applicable
        </Typography>
      )}
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "appealDetailsDDoc",
          ml: 2,
          removeUpload,
        }}
      />
      {/* 4 */}
      <RadioButtons
        title={
          "4. Does the entity have an anti-corruption or anti-bribery policy? If yes, provide details in brief and if available, provide a web-link to the policy."
        }
        disabled={disabled}
        value={formData?.antiCorruptionPolicy?.hasPolicy || false}
        handleChange={(e) => {
          const value = e.target.value === "true";
          setFormData((prev) => ({
            ...prev,
            antiCorruptionPolicy: {
              ...prev.antiCorruptionPolicy,
              hasPolicy: value,
            },
          }));
          setErrors((prev) => ({
            ...prev,
            antiCorruptionPolicy: {
              policyDetails: "",
              policyLink: "",
            },
          }));
        }}
      />
      {formData?.antiCorruptionPolicy?.hasPolicy ? (
        <Box sx={{ display: "flex", gap: 2, ml: 2 }}>
          <Box sx={{ display: "flex", flexDirection: "column", width: "50%" }}>
            <Typography
              sx={{
                fontWeight: 500,
                fontFamily: "Inter",
                fontSize: "15px",
                lineHeight: "22px",
              }}
            >
              Details of Policy
            </Typography>
            <InputField
              {...{
                handleChange,
                disabled,
                placeholder: "Enter Text",
                errors: errors["antiCorruptionPolicy.policyDetails"] && true,
                fieldName: "antiCorruptionPolicy.policyDetails",
                value: formData?.antiCorruptionPolicy?.policyDetails,
              }}
            />
            <p
              color="error"
              variant="caption"
              style={{
                lineHeight: "1.2",
                margin: "2px 0",
                marginTop: "5px",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
              }}
            >
              {errors["antiCorruptionPolicy.policyDetails"]}
            </p>
          </Box>
          <Box sx={{ width: "48%" }}>
            <Typography
              sx={{
                fontWeight: 500,
                fontFamily: "Inter",
                fontSize: "15px",
                lineHeight: "22px",
              }}
            >
              Web Link
            </Typography>
            <InputField
              handleChange={handleChange}
              fieldName="antiCorruptionPolicy.policyLink"
              errors={errors["antiCorruptionPolicy.policyLink"] && true}
              placeholder={"Enter Text"}
              // mt={1}
              disabled={disabled}
              value={formData?.antiCorruptionPolicy?.policyLink || ""}
            />
            <p
              color="error"
              variant="caption"
              style={{
                lineHeight: "1.2",
                margin: "2px 0",
                marginTop: "5px",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
              }}
            >
              {errors["antiCorruptionPolicy.policyLink"]}
            </p>
          </Box>
        </Box>
      ) : null}
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "antiCorruptionPolicyDoc",
          ml: 2,
          removeUpload,
        }}
      />
      {/* 5 */}
      <TableData
        defaultSegments={defaultSegments?.desciplinary || ""}
        inputData={inputData.disciplinaryData}
        errors={errors["desciplinary"]}
        setErrors={setErrors}
        tables={desciplinaryTable}
        setTables={setDesciplinaryTable}
        name="desciplinary"
        defaultWidth={"10rem"}
        disabled={disabled}
      />
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "disciplinaryActionsDoc",
          ml: 2,
          removeUpload,
        }}
      />
      {/* 6 */}
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <Typography variant="subtitle1" sx={{ fontWeight: "bold", my: "1rem" }}>
        6. Details of complaints with regard to conflict of interest:
      </Typography>
      <ComplaintTable
        {...{
          setFormData,
          formData,
          setErrors: setComplaintError,
          errors: complaintError,
          disabled,
        }}
      />
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "conflictOfInterestComplaintsDoc",
          ml: 2,
          removeUpload,
        }}
      />
      {/* 7 */}
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <Box>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: "bold",
            my: "1rem",
            textIndent: "-1.1rem",
            ml: "1rem",
          }}
        >
          7. Provide details of any corrective action taken or underway on
          issues related to fines/ penalties/ action taken by regulators/ law
          enforcement agencies/ judicial institutions, on cases of corruption
          and conflicts of interest.
        </Typography>
        <Box sx={{ ml: 2, width: "98%" }}>
          <InputField
            fieldName={"correctiveActions"}
            placeholder={"Enter Text"}
            errors={errors["correctiveActions"] && true}
            value={formData?.correctiveActions}
            handleChange={handleChange}
            disabled={disabled}
          />
          <p
            color="error"
            variant="caption"
            style={{
              lineHeight: "1.2",
              margin: "2px 0",
              marginTop: "5px",
              color: "#d34040",
              fontSize: "10px",
              fontStyle: "italic",
            }}
          >
            {errors["correctiveActions"]}
          </p>
        </Box>
      </Box>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "correctiveActionsDoc",
          ml: 2,
          removeUpload,
        }}
      />
      {/* 8 */}
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: "bold", my: "1rem", textIndent: "-1rem", ml: "1rem" }}
      >
        8. Number of days of accounts payables [(Accounts payable*365)/ Cost of
        goods/services procured)]
      </Typography>
      <Box sx={{ display: "flex", gap: 2, ml: 2 }}>
        <Box sx={{ display: "flex", flexDirection: "column", width: "49%" }}>
          <Typography
            sx={{
              fontWeight: 500,
              fontFamily: "Inter",
              fontSize: "15px",
              lineHeight: "22px",
            }}
          >
            Number of Days (in Current Financial Year )
          </Typography>
          <InputField
            {...{
              handleChange,
              disabled,
              placeholder: "Enter Number",
              errors: errors["accountsPayables.currentFinancialYear"] && true,
              fieldName: "accountsPayables.currentFinancialYear",
              value: formData?.accountsPayables?.currentFinancialYear ?? "",
            }}
          />
          <p
            color="error"
            variant="caption"
            style={{
              lineHeight: "1.2",
              margin: "2px 0",
              marginTop: "5px",
              color: "#d34040",
              fontSize: "10px",
              fontStyle: "italic",
            }}
          >
            {errors["accountsPayables.currentFinancialYear"]}
          </p>
        </Box>
        <Box sx={{ width: "48.8%" }}>
          <Typography
            sx={{
              fontWeight: 500,
              fontFamily: "Inter",
              fontSize: "15px",
              lineHeight: "22px",
            }}
          >
            Number of Days (in Previous Financial Year )
          </Typography>
          <InputField
            {...{
              handleChange,
              disabled,
              errors: errors["accountsPayables.previousFinancialYear"] && true,
              placeholder: "Enter Number",
              fieldName: "accountsPayables.previousFinancialYear",
              value: formData?.accountsPayables?.previousFinancialYear ?? "",
            }}
          />
          <p
            color="error"
            variant="caption"
            style={{
              lineHeight: "1.2",
              margin: "2px 0",
              marginTop: "5px",
              color: "#d34040",
              fontSize: "10px",
              fontStyle: "italic",
            }}
          >
            {errors["accountsPayables.previousFinancialYear"]}
          </p>
        </Box>
      </Box>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "accountsPayablesDoc",
          ml: 2,
          removeUpload,
        }}
      />
      {/* 9 */}
      {downloadMode ? <Box sx={{ pageBreakBefore: "always" }} /> : null}
      <Box
        sx={{
          display: "flex",
          gap: 0.75,
          alignItems: "flex-start",
          my: "1rem",
          ml: "1rem",
          lineHeight: 1.45,
        }}
      >
        <Typography
          component="span"
          variant="subtitle1"
          sx={{ fontWeight: "bold", flexShrink: 0 }}
        >
          9.
        </Typography>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            Open-ness of business
          </Typography>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            {
              "Details of concentration of purchases and sales with trading houses, dealers, and related parties along-with loans and advances & investments, with related parties:"
            }
          </Typography>
        </Box>
      </Box>
      <RelatedTransactionsTable
        {...{
          formData,
          setFormData,
          disabled,
          data: inputData.relatedPartyTransactionsData,
          errors: relatedErrors,
          setErrors: setRelatedErrors,
          currentFyColumnLabel: relatedPartyFyColumnLabels.current,
          previousFyColumnLabel: relatedPartyFyColumnLabels.previous,
        }}
      />
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "relatedPartyTransactionsDoc",
          ml: 2,
          removeUpload,
        }}
      />
      {/* Submit Button */}
      {!hide && (
        <>
          {brsrReview ? (
            <Box sx={{ ml: "1rem", width: "98%" }}>
              <ReviewBox
                url={`/brsr/review/${id}`}
                handleSubmit={handleSubmit}
              />
            </Box>
          ) : (
            <Box textAlign="right" sx={{ mt: 3 }}>
              <Button
                onClick={handleSubmit}
                variant="contained"
                sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
              >
                Save & Continue <EastIcon sx={{ ml: 2 }} />
              </Button>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default EssentialIndicator;
